// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1m9Pf","title":"Images90_title__2phre","images":"Images90_images__2ag4_"};